import axios from 'axios';
import { getContentProvider } from '@/helper/auth';

// eslint-disable-next-line import/prefer-default-export
export const getPreviewUrl = ({ mediaContentId, profileKey }) => {
    const { key } = getContentProvider();
    const params = {
        profile_key: profileKey,
    };

    return axios.get(`/cms/${key}/programs/media_contents/${mediaContentId}/preview_url`, {
        params,
    });
};
